import {
  GET_APPLICANTDOCUMENT,
  GET_APPLICANTDOCUMENT_SUCCESS,
  GET_APPLICANTDOCUMENT_FAIL,
  DELETE_APPLICANTDOCUMENT,
  DELETE_APPLICANTDOCUMENT_SUCCESS,
  DELETE_APPLICANTDOCUMENT_FAIL,
  UPDATE_APPLICANTDOCUMENT,
  UPDATE_APPLICANTDOCUMENT_SUCCESS,
  UPDATE_APPLICANTDOCUMENT_FAIL,
  ADD_NEW_APPLICANTDOCUMENT,
  ADD_APPLICANTDOCUMENT_SUCCESS,
  ADD_APPLICANTDOCUMENT_FAIL,
  APPLICANTDOCUMENT_LOADING,
  APPLICANTDOCUMENT_RESET
} from "./actionType";

export const resetApplicantDocumentState = (actionType) => ({
  type: APPLICANTDOCUMENT_RESET,
  payload: { actionType },
});

export const getApplicantDocumentSuccess = (actionType, data) => ({
  type: GET_APPLICANTDOCUMENT_SUCCESS,
  payload: { actionType, data },
});

export const getApplicantDocumentFail = (actionType, error) => ({
  type: GET_APPLICANTDOCUMENT_FAIL,
  payload: { actionType, error },
});

export const getApplicantDocument = data => ({
  type: GET_APPLICANTDOCUMENT,
  payload: data,
});

export const getApplicantDocumentLoading = () => ({
  type: APPLICANTDOCUMENT_LOADING
});

export const deleteApplicantDocument = data => ({
  type: DELETE_APPLICANTDOCUMENT,
  payload: data,
});

export const deleteApplicantDocumentSuccess = data => ({
  type: DELETE_APPLICANTDOCUMENT_SUCCESS,
  payload: data,
});

export const deleteApplicantDocumentFail = error => ({
  type: DELETE_APPLICANTDOCUMENT_FAIL,
  payload: error,
});

export const updateApplicantDocument = data => ({
  type: UPDATE_APPLICANTDOCUMENT,
  payload: data,
});

export const updateApplicantDocumentFail = error => ({
  type: UPDATE_APPLICANTDOCUMENT_FAIL,
  payload: error,
});

export const updateApplicantDocumentSuccess = data => ({
  type: UPDATE_APPLICANTDOCUMENT_SUCCESS,
  payload: data,
});

export const addNewApplicantDocument = data => ({
  type: ADD_NEW_APPLICANTDOCUMENT,
  payload: data,
});

export const addApplicantDocumentSuccess = data => ({
  type: ADD_APPLICANTDOCUMENT_SUCCESS,
  payload: data,
});

export const addApplicantDocumentFail = error => ({
  type: ADD_APPLICANTDOCUMENT_FAIL,
  payload: error,
});